import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";

const testCandidates = [
  {
    candidateId: "CAN2024001",
    firstName: "Luan",
    lastName: "Hajdari",
    phoneNumber: "+383 44 111 222",
    email: "luan.hajdari@email.com",
    personalNumber: "1234567890",
    username: "luanh",
    password: "LH7890",
    birthday: "2002-05-15",
    gender: "male",
    address: "Rr. Dardania, Nr. 12, Prishtinë",
    parentName: "Agim Hajdari",
    startDate: "2024-01-15",
    category: "B",
    assignedInstructor: "Arben Krasniqi",
    totalHours: "40",
    bonusHours: "5",
    totalAmount: "650",
    paidAmount: "650",
    theoryTestDate: "2024-02-20",
    practicalTestDate: "2024-03-15",
    status: "completed",
    notes: "Excellent student, passed on first attempt",
  },
  {
    candidateId: "CAN2024002",
    firstName: "Rina",
    lastName: "Morina",
    phoneNumber: "+383 49 222 333",
    email: "rina.morina@email.com",
    personalNumber: "2345678901",
    username: "rinam",
    password: "RM8901",
    birthday: "2003-08-22",
    gender: "female",
    address: "Rr. Nëna Tereze, Nr. 45, Prizren",
    parentName: "Fadil Morina",
    startDate: "2024-02-01",
    category: "B",
    assignedInstructor: "Besarta Mustafa",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "400",
    theoryTestDate: "2024-03-10",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024003",
    firstName: "Alban",
    lastName: "Shala",
    phoneNumber: "+383 45 333 444",
    email: "",
    personalNumber: "3456789012",
    username: "albans",
    password: "AS9012",
    birthday: "2001-12-10",
    gender: "male",
    address: "Rr. UCK, Nr. 78, Pejë",
    parentName: "Nexhat Shala",
    startDate: "2023-11-20",
    category: "B",
    assignedInstructor: "Driton Berisha",
    totalHours: "40",
    bonusHours: "3",
    totalAmount: "620",
    paidAmount: "620",
    theoryTestDate: "2024-01-05",
    practicalTestDate: "2024-02-10",
    status: "completed",
    notes: "Very focused student",
  },
  {
    candidateId: "CAN2024004",
    firstName: "Diellza",
    lastName: "Kelmendi",
    phoneNumber: "+383 44 444 555",
    email: "diellza.k@email.com",
    personalNumber: "4567890123",
    username: "diellzak",
    password: "DK0123",
    birthday: "2004-03-18",
    gender: "female",
    address: "",
    parentName: "Ismet Kelmendi",
    startDate: "2024-03-01",
    category: "B",
    assignedInstructor: "Linda Hyseni",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "200",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "Beginner, needs extra practice",
  },
  {
    candidateId: "CAN2024005",
    firstName: "Blend",
    lastName: "Gashi",
    phoneNumber: "+383 49 555 666",
    email: "blend.gashi@email.com",
    personalNumber: "5678901234",
    username: "blendg",
    password: "BG1234",
    birthday: "2000-07-25",
    gender: "male",
    address: "Rr. Bill Clinton, Nr. 23, Prishtinë",
    parentName: "",
    startDate: "2024-01-10",
    category: "C",
    assignedInstructor: "Agron Shala",
    totalHours: "60",
    bonusHours: "10",
    totalAmount: "1200",
    paidAmount: "1200",
    theoryTestDate: "2024-02-15",
    practicalTestDate: "2024-03-20",
    status: "completed",
    notes: "Truck license, professional driver",
  },
  {
    candidateId: "CAN2024006",
    firstName: "Elona",
    lastName: "Berisha",
    phoneNumber: "+383 45 666 777",
    email: "elona.berisha@email.com",
    personalNumber: "6789012345",
    username: "elonab",
    password: "EB2345",
    birthday: "2003-11-05",
    gender: "female",
    address: "Rr. Skënderbeu, Nr. 56, Gjakovë",
    parentName: "Ramadan Berisha",
    startDate: "2024-02-15",
    category: "B",
    assignedInstructor: "Teuta Kelmendi",
    totalHours: "40",
    bonusHours: "2",
    totalAmount: "610",
    paidAmount: "300",
    theoryTestDate: "2024-03-25",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024007",
    firstName: "Ardit",
    lastName: "Demolli",
    phoneNumber: "+383 44 777 888",
    email: "",
    personalNumber: "7890123456",
    username: "arditd",
    password: "AD3456",
    birthday: "2002-09-14",
    gender: "male",
    address: "Rr. Dëshmorët, Nr. 34, Mitrovicë",
    parentName: "Kujtim Demolli",
    startDate: "2024-02-10",
    category: "B",
    assignedInstructor: "Drita Kastrati",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "0",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "paused",
    notes: "Payment pending, lessons paused",
  },
  {
    candidateId: "CAN2024008",
    firstName: "Fatjona",
    lastName: "Rexha",
    phoneNumber: "+383 49 888 999",
    email: "fatjona.rexha@email.com",
    personalNumber: "8901234567",
    username: "fatjonar",
    password: "FR4567",
    birthday: "2001-04-20",
    gender: "female",
    address: "Rr. Lidhja e Prizrenit, Nr. 89, Vushtrri",
    parentName: "Shpend Rexha",
    startDate: "2023-12-01",
    category: "B",
    assignedInstructor: "Arlinda Sylejmani",
    totalHours: "40",
    bonusHours: "5",
    totalAmount: "650",
    paidAmount: "650",
    theoryTestDate: "2024-01-15",
    practicalTestDate: "2024-02-20",
    status: "failed",
    notes: "Failed practical test, needs retry",
  },
  {
    candidateId: "CAN2024009",
    firstName: "Granit",
    lastName: "Limani",
    phoneNumber: "+383 45 999 000",
    email: "granit.limani@email.com",
    personalNumber: "9012345678",
    username: "granitl",
    password: "GL5678",
    birthday: "2003-01-30",
    gender: "male",
    address: "Rr. Ismail Qemali, Nr. 67, Ferizaj",
    parentName: "Halil Limani",
    startDate: "2024-03-05",
    category: "A",
    assignedInstructor: "Driton Berisha",
    totalHours: "30",
    bonusHours: "0",
    totalAmount: "500",
    paidAmount: "250",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "Motorcycle license",
  },
  {
    candidateId: "CAN2024010",
    firstName: "Hana",
    lastName: "Vitija",
    phoneNumber: "+383 44 000 111",
    email: "",
    personalNumber: "0123456789",
    username: "hanav",
    password: "HV6789",
    birthday: "2004-06-12",
    gender: "female",
    address: "",
    parentName: "Sokol Vitija",
    startDate: "2024-02-20",
    category: "B",
    assignedInstructor: "Afërdita Hoxha",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "600",
    theoryTestDate: "2024-03-28",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024011",
    firstName: "Ilir",
    lastName: "Kastrati",
    phoneNumber: "+383 49 111 222",
    email: "ilir.kastrati@email.com",
    personalNumber: "1122334455",
    username: "ilirk",
    password: "IK4455",
    birthday: "2001-10-08",
    gender: "male",
    address: "Rr. Zahir Pajaziti, Nr. 45, Gjilan",
    parentName: "",
    startDate: "2023-10-15",
    category: "B",
    assignedInstructor: "Flamur Gashi",
    totalHours: "40",
    bonusHours: "8",
    totalAmount: "680",
    paidAmount: "680",
    theoryTestDate: "2023-11-20",
    practicalTestDate: "2024-01-10",
    status: "completed",
    notes: "Excellent performance throughout",
  },
  {
    candidateId: "CAN2024012",
    firstName: "Jetmira",
    lastName: "Osmani",
    phoneNumber: "+383 45 222 333",
    email: "jetmira.osmani@email.com",
    personalNumber: "2233445566",
    username: "jetmirao",
    password: "JO5566",
    birthday: "2002-02-17",
    gender: "female",
    address: "Rr. Adem Jashari, Nr. 12, Prishtinë",
    parentName: "Shaban Osmani",
    startDate: "2024-01-20",
    category: "B",
    assignedInstructor: "Linda Hyseni",
    totalHours: "40",
    bonusHours: "3",
    totalAmount: "620",
    paidAmount: "620",
    theoryTestDate: "2024-02-25",
    practicalTestDate: "2024-03-18",
    status: "completed",
    notes: "",
  },
  {
    candidateId: "CAN2024013",
    firstName: "Korab",
    lastName: "Tahiri",
    phoneNumber: "+383 44 333 444",
    email: "",
    personalNumber: "3344556677",
    username: "korabt",
    password: "KT6677",
    birthday: "2003-09-25",
    gender: "male",
    address: "Rr. Xhelal Hajda, Nr. 90, Suharekë",
    parentName: "Musa Tahiri",
    startDate: "2024-03-10",
    category: "B",
    assignedInstructor: "Mentor Shabani",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "150",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024014",
    firstName: "Loreta",
    lastName: "Sylejmani",
    phoneNumber: "+383 49 444 555",
    email: "loreta.sylejmani@email.com",
    personalNumber: "4455667788",
    username: "loretas",
    password: "LS7788",
    birthday: "2001-12-03",
    gender: "female",
    address: "Rr. Ukshin Hoti, Nr. 34, Deçan",
    parentName: "Bekim Sylejmani",
    startDate: "2024-01-05",
    category: "B",
    assignedInstructor: "Teuta Kelmendi",
    totalHours: "40",
    bonusHours: "4",
    totalAmount: "630",
    paidAmount: "630",
    theoryTestDate: "2024-02-10",
    practicalTestDate: "2024-03-05",
    status: "completed",
    notes: "Quick learner",
  },
  {
    candidateId: "CAN2024015",
    firstName: "Meriton",
    lastName: "Shabani",
    phoneNumber: "+383 45 555 666",
    email: "meriton.shabani@email.com",
    personalNumber: "5566778899",
    username: "meritons",
    password: "MS8899",
    birthday: "2004-05-11",
    gender: "male",
    address: "Rr. Bajram Kelmendi, Nr. 23, Klinë",
    parentName: "Valdet Shabani",
    startDate: "2024-02-25",
    category: "B",
    assignedInstructor: "Shkëlzen Osmani",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "300",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024016",
    firstName: "Nora",
    lastName: "Krasniqi",
    phoneNumber: "+383 44 666 777",
    email: "",
    personalNumber: "6677889900",
    username: "norak",
    password: "NK9900",
    birthday: "2002-08-19",
    gender: "female",
    address: "Rr. Mbretëresha Teutë, Nr. 56, Prishtinë",
    parentName: "Afrim Krasniqi",
    startDate: "2024-01-25",
    category: "B",
    assignedInstructor: "Arlinda Sylejmani",
    totalHours: "40",
    bonusHours: "2",
    totalAmount: "610",
    paidAmount: "610",
    theoryTestDate: "2024-03-01",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024017",
    firstName: "Olti",
    lastName: "Hoxha",
    phoneNumber: "+383 49 777 888",
    email: "olti.hoxha@email.com",
    personalNumber: "7788990011",
    username: "oltih",
    password: "OH0011",
    birthday: "2003-03-28",
    gender: "male",
    address: "Rr. Garibaldi, Nr. 78, Prizren",
    parentName: "Ilir Hoxha",
    startDate: "2023-12-10",
    category: "B",
    assignedInstructor: "Ramiz Dervishi",
    totalHours: "40",
    bonusHours: "6",
    totalAmount: "660",
    paidAmount: "660",
    theoryTestDate: "2024-01-20",
    practicalTestDate: "2024-02-15",
    status: "completed",
    notes: "",
  },
  {
    candidateId: "CAN2024018",
    firstName: "Pranvera",
    lastName: "Mustafa",
    phoneNumber: "+383 45 888 999",
    email: "pranvera.mustafa@email.com",
    personalNumber: "8899001122",
    username: "pranveram",
    password: "PM1122",
    birthday: "2001-07-14",
    gender: "female",
    address: "Rr. Elez Berisha, Nr. 45, Istog",
    parentName: "Rrahim Mustafa",
    startDate: "2024-02-05",
    category: "B",
    assignedInstructor: "Besarta Mustafa",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "450",
    theoryTestDate: "2024-03-15",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024019",
    firstName: "Qendrim",
    lastName: "Gashi",
    phoneNumber: "+383 44 999 000",
    email: "",
    personalNumber: "9900112233",
    username: "qendrimg",
    password: "QG2233",
    birthday: "2004-11-22",
    gender: "male",
    address: "",
    parentName: "Lulzim Gashi",
    startDate: "2024-03-15",
    category: "B",
    assignedInstructor: "Valmir Tahiri",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "100",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "Just started",
  },
  {
    candidateId: "CAN2024020",
    firstName: "Rozafa",
    lastName: "Demolli",
    phoneNumber: "+383 49 000 111",
    email: "rozafa.demolli@email.com",
    personalNumber: "0011223344",
    username: "rozafad",
    password: "RD3344",
    birthday: "2002-04-07",
    gender: "female",
    address: "Rr. Hasan Prishtina, Nr. 12, Rahovec",
    parentName: "Artan Demolli",
    startDate: "2024-01-12",
    category: "B",
    assignedInstructor: "Drita Kastrati",
    totalHours: "40",
    bonusHours: "5",
    totalAmount: "650",
    paidAmount: "650",
    theoryTestDate: "2024-02-18",
    practicalTestDate: "2024-03-12",
    status: "completed",
    notes: "",
  },
  {
    candidateId: "CAN2024021",
    firstName: "Shpend",
    lastName: "Berisha",
    phoneNumber: "+383 45 111 222",
    email: "shpend.berisha@email.com",
    personalNumber: "1231231234",
    username: "shpendb",
    password: "SB1234",
    birthday: "2003-06-16",
    gender: "male",
    address: "Rr. Agim Ramadani, Nr. 67, Malishevë",
    parentName: "",
    startDate: "2024-02-28",
    category: "B",
    assignedInstructor: "Flamur Gashi",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "350",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024022",
    firstName: "Tringa",
    lastName: "Shala",
    phoneNumber: "+383 44 222 333",
    email: "tringa.shala@email.com",
    personalNumber: "2342342345",
    username: "tringas",
    password: "TS2345",
    birthday: "2001-09-29",
    gender: "female",
    address: "Rr. Fehmi Agani, Nr. 34, Pejë",
    parentName: "Gani Shala",
    startDate: "2023-11-01",
    category: "B",
    assignedInstructor: "Linda Hyseni",
    totalHours: "40",
    bonusHours: "7",
    totalAmount: "670",
    paidAmount: "670",
    theoryTestDate: "2023-12-10",
    practicalTestDate: "2024-01-25",
    status: "completed",
    notes: "Very dedicated student",
  },
  {
    candidateId: "CAN2024023",
    firstName: "Urim",
    lastName: "Morina",
    phoneNumber: "+383 49 333 444",
    email: "",
    personalNumber: "3453453456",
    username: "urimm",
    password: "UM3456",
    birthday: "2002-12-24",
    gender: "male",
    address: "Rr. UCK, Nr. 89, Prishtinë",
    parentName: "Naim Morina",
    startDate: "2024-03-20",
    category: "A1",
    assignedInstructor: "Driton Berisha",
    totalHours: "25",
    bonusHours: "0",
    totalAmount: "450",
    paidAmount: "200",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "Light motorcycle",
  },
  {
    candidateId: "CAN2024024",
    firstName: "Valdete",
    lastName: "Kelmendi",
    phoneNumber: "+383 45 444 555",
    email: "valdete.kelmendi@email.com",
    personalNumber: "4564564567",
    username: "valdetek",
    password: "VK4567",
    birthday: "2004-02-11",
    gender: "female",
    address: "Rr. Nëna Tereze, Nr. 23, Prizren",
    parentName: "Bardhyl Kelmendi",
    startDate: "2024-02-12",
    category: "B",
    assignedInstructor: "Teuta Kelmendi",
    totalHours: "40",
    bonusHours: "1",
    totalAmount: "605",
    paidAmount: "400",
    theoryTestDate: "2024-03-20",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024025",
    firstName: "Xhevdet",
    lastName: "Limani",
    phoneNumber: "+383 44 555 666",
    email: "xhevdet.limani@email.com",
    personalNumber: "5675675678",
    username: "xhevdetl",
    password: "XL5678",
    birthday: "2001-05-19",
    gender: "male",
    address: "Rr. Skënderbeu, Nr. 45, Gjakovë",
    parentName: "Shaqir Limani",
    startDate: "2024-01-08",
    category: "D",
    assignedInstructor: "Mentor Shabani",
    totalHours: "80",
    bonusHours: "15",
    totalAmount: "1800",
    paidAmount: "1800",
    theoryTestDate: "2024-02-22",
    practicalTestDate: "2024-03-25",
    status: "completed",
    notes: "Bus license, professional training",
  },
  {
    candidateId: "CAN2024026",
    firstName: "Yllka",
    lastName: "Vitija",
    phoneNumber: "+383 49 666 777",
    email: "",
    personalNumber: "6786786789",
    username: "yllkav",
    password: "YV6789",
    birthday: "2003-10-05",
    gender: "female",
    address: "",
    parentName: "Hysen Vitija",
    startDate: "2024-02-18",
    category: "B",
    assignedInstructor: "Arlinda Sylejmani",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "250",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024027",
    firstName: "Zenun",
    lastName: "Tahiri",
    phoneNumber: "+383 45 777 888",
    email: "zenun.tahiri@email.com",
    personalNumber: "7897897890",
    username: "zenunt",
    password: "ZT7890",
    birthday: "2002-01-26",
    gender: "male",
    address: "Rr. Bill Clinton, Nr. 56, Prishtinë",
    parentName: "",
    startDate: "2024-01-18",
    category: "B",
    assignedInstructor: "Ramiz Dervishi",
    totalHours: "40",
    bonusHours: "4",
    totalAmount: "630",
    paidAmount: "630",
    theoryTestDate: "2024-02-28",
    practicalTestDate: "2024-03-22",
    status: "completed",
    notes: "",
  },
  {
    candidateId: "CAN2024028",
    firstName: "Agnesa",
    lastName: "Kastrati",
    phoneNumber: "+383 44 888 999",
    email: "agnesa.kastrati@email.com",
    personalNumber: "8908908901",
    username: "agnesak",
    password: "AK8901",
    birthday: "2004-07-08",
    gender: "female",
    address: "Rr. Dardania, Nr. 78, Prishtinë",
    parentName: "Sami Kastrati",
    startDate: "2024-03-12",
    category: "B",
    assignedInstructor: "Besarta Mustafa",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "180",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024029",
    firstName: "Besnik",
    lastName: "Osmani",
    phoneNumber: "+383 49 999 000",
    email: "",
    personalNumber: "9019019012",
    username: "besniko",
    password: "BO9012",
    birthday: "2001-11-13",
    gender: "male",
    address: "Rr. Lidhja e Prizrenit, Nr. 12, Vushtrri",
    parentName: "Ramadan Osmani",
    startDate: "2024-02-22",
    category: "B",
    assignedInstructor: "Shkëlzen Osmani",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "0",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "paused",
    notes: "Financial issues, temporarily paused",
  },
  {
    candidateId: "CAN2024030",
    firstName: "Çlirim",
    lastName: "Rexha",
    phoneNumber: "+383 45 000 111",
    email: "clirim.rexha@email.com",
    personalNumber: "0120120123",
    username: "clirimr",
    password: "CR0123",
    birthday: "2003-04-30",
    gender: "male",
    address: "Rr. Ismail Qemali, Nr. 34, Ferizaj",
    parentName: "Florim Rexha",
    startDate: "2023-12-05",
    category: "B",
    assignedInstructor: "Flamur Gashi",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "600",
    theoryTestDate: "2024-01-12",
    practicalTestDate: "2024-02-05",
    status: "failed",
    notes: "Failed practical, scheduling retry",
  },
  {
    candidateId: "CAN2024031",
    firstName: "Doruntina",
    lastName: "Sylejmani",
    phoneNumber: "+383 44 111 000",
    email: "doruntina.sylejmani@email.com",
    personalNumber: "1231234567",
    username: "doruntinas",
    password: "DS4567",
    birthday: "2002-08-21",
    gender: "female",
    address: "Rr. Zahir Pajaziti, Nr. 89, Gjilan",
    parentName: "Enver Sylejmani",
    startDate: "2024-01-22",
    category: "B",
    assignedInstructor: "Drita Kastrati",
    totalHours: "40",
    bonusHours: "3",
    totalAmount: "620",
    paidAmount: "620",
    theoryTestDate: "2024-03-02",
    practicalTestDate: "2024-03-28",
    status: "active",
    notes: "Ready for practical test",
  },
  {
    candidateId: "CAN2024032",
    firstName: "Edon",
    lastName: "Shabani",
    phoneNumber: "+383 49 222 111",
    email: "",
    personalNumber: "2342345678",
    username: "edons",
    password: "ES5678",
    birthday: "2004-03-15",
    gender: "male",
    address: "Rr. Adem Jashari, Nr. 67, Prishtinë",
    parentName: "Gezim Shabani",
    startDate: "2024-03-08",
    category: "B",
    assignedInstructor: "Valmir Tahiri",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "220",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024033",
    firstName: "Fatlinda",
    lastName: "Krasniqi",
    phoneNumber: "+383 45 333 222",
    email: "fatlinda.krasniqi@email.com",
    personalNumber: "3453456789",
    username: "fatlindak",
    password: "FK6789",
    birthday: "2001-12-09",
    gender: "female",
    address: "Rr. Xhelal Hajda, Nr. 23, Suharekë",
    parentName: "Tahir Krasniqi",
    startDate: "2024-01-15",
    category: "B",
    assignedInstructor: "Linda Hyseni",
    totalHours: "40",
    bonusHours: "6",
    totalAmount: "660",
    paidAmount: "660",
    theoryTestDate: "2024-02-24",
    practicalTestDate: "2024-03-16",
    status: "completed",
    notes: "Excellent student",
  },
  {
    candidateId: "CAN2024034",
    firstName: "Genc",
    lastName: "Hoxha",
    phoneNumber: "+383 44 444 333",
    email: "genc.hoxha@email.com",
    personalNumber: "4564567890",
    username: "gench",
    password: "GH7890",
    birthday: "2003-05-27",
    gender: "male",
    address: "",
    parentName: "Astrit Hoxha",
    startDate: "2024-02-08",
    category: "C",
    assignedInstructor: "Agron Shala",
    totalHours: "60",
    bonusHours: "8",
    totalAmount: "1250",
    paidAmount: "800",
    theoryTestDate: "2024-03-18",
    practicalTestDate: "",
    status: "active",
    notes: "Truck license in progress",
  },
  {
    candidateId: "CAN2024035",
    firstName: "Hjona",
    lastName: "Mustafa",
    phoneNumber: "+383 49 555 444",
    email: "",
    personalNumber: "5675678901",
    username: "hjonam",
    password: "HM8901",
    birthday: "2002-09-04",
    gender: "female",
    address: "Rr. Ukshin Hoti, Nr. 45, Deçan",
    parentName: "Naser Mustafa",
    startDate: "2024-02-15",
    category: "B",
    assignedInstructor: "Teuta Kelmendi",
    totalHours: "40",
    bonusHours: "2",
    totalAmount: "610",
    paidAmount: "500",
    theoryTestDate: "2024-03-25",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024036",
    firstName: "Ibrahim",
    lastName: "Demolli",
    phoneNumber: "+383 45 666 555",
    email: "ibrahim.demolli@email.com",
    personalNumber: "6786789012",
    username: "ibrahimd",
    password: "ID9012",
    birthday: "2001-02-18",
    gender: "male",
    address: "Rr. Bajram Kelmendi, Nr. 78, Klinë",
    parentName: "",
    startDate: "2023-11-15",
    category: "B",
    assignedInstructor: "Ramiz Dervishi",
    totalHours: "40",
    bonusHours: "5",
    totalAmount: "650",
    paidAmount: "650",
    theoryTestDate: "2023-12-22",
    practicalTestDate: "2024-01-30",
    status: "completed",
    notes: "",
  },
  {
    candidateId: "CAN2024037",
    firstName: "Jehona",
    lastName: "Gashi",
    phoneNumber: "+383 44 777 666",
    email: "jehona.gashi@email.com",
    personalNumber: "7897890123",
    username: "jehonag",
    password: "JG0123",
    birthday: "2004-06-23",
    gender: "female",
    address: "Rr. Mbretëresha Teutë, Nr. 12, Prishtinë",
    parentName: "Bujar Gashi",
    startDate: "2024-03-18",
    category: "B",
    assignedInstructor: "Arlinda Sylejmani",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "150",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "Just started lessons",
  },
  {
    candidateId: "CAN2024038",
    firstName: "Kaltrina",
    lastName: "Berisha",
    phoneNumber: "+383 49 888 777",
    email: "",
    personalNumber: "8908901234",
    username: "kaltrinab",
    password: "KB1234",
    birthday: "2002-10-31",
    gender: "female",
    address: "Rr. Garibaldi, Nr. 34, Prizren",
    parentName: "Driton Berisha",
    startDate: "2024-01-28",
    category: "B",
    assignedInstructor: "Besarta Mustafa",
    totalHours: "40",
    bonusHours: "4",
    totalAmount: "630",
    paidAmount: "630",
    theoryTestDate: "2024-03-05",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024039",
    firstName: "Labinot",
    lastName: "Shala",
    phoneNumber: "+383 45 999 888",
    email: "labinot.shala@email.com",
    personalNumber: "9019012345",
    username: "labinots",
    password: "LS2345",
    birthday: "2003-01-12",
    gender: "male",
    address: "Rr. Elez Berisha, Nr. 56, Istog",
    parentName: "Fejzo Shala",
    startDate: "2024-02-03",
    category: "B",
    assignedInstructor: "Shkëlzen Osmani",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "600",
    theoryTestDate: "2024-03-12",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024040",
    firstName: "Majlinda",
    lastName: "Limani",
    phoneNumber: "+383 44 000 999",
    email: "majlinda.limani@email.com",
    personalNumber: "0120123456",
    username: "majlindal",
    password: "ML3456",
    birthday: "2001-07-19",
    gender: "female",
    address: "Rr. Hasan Prishtina, Nr. 89, Rahovec",
    parentName: "Rrustem Limani",
    startDate: "2023-12-12",
    category: "B",
    assignedInstructor: "Drita Kastrati",
    totalHours: "40",
    bonusHours: "7",
    totalAmount: "670",
    paidAmount: "670",
    theoryTestDate: "2024-01-18",
    practicalTestDate: "2024-02-28",
    status: "completed",
    notes: "Very confident driver",
  },
  {
    candidateId: "CAN2024041",
    firstName: "Naim",
    lastName: "Vitija",
    phoneNumber: "+383 49 111 000",
    email: "",
    personalNumber: "1231235678",
    username: "naimv",
    password: "NV5678",
    birthday: "2004-04-14",
    gender: "male",
    address: "Rr. Agim Ramadani, Nr. 23, Malishevë",
    parentName: "Xhevat Vitija",
    startDate: "2024-03-22",
    category: "B",
    assignedInstructor: "Flamur Gashi",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "100",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024042",
    firstName: "Ornela",
    lastName: "Kastrati",
    phoneNumber: "+383 45 222 000",
    email: "ornela.kastrati@email.com",
    personalNumber: "2342346789",
    username: "ornelak",
    password: "OK6789",
    birthday: "2002-11-28",
    gender: "female",
    address: "",
    parentName: "Muharrem Kastrati",
    startDate: "2024-02-10",
    category: "B",
    assignedInstructor: "Linda Hyseni",
    totalHours: "40",
    bonusHours: "1",
    totalAmount: "605",
    paidAmount: "405",
    theoryTestDate: "2024-03-20",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024043",
    firstName: "Petrit",
    lastName: "Morina",
    phoneNumber: "+383 44 333 000",
    email: "petrit.morina@email.com",
    personalNumber: "3453457890",
    username: "petritm",
    password: "PM7890",
    birthday: "2001-08-06",
    gender: "male",
    address: "Rr. Fehmi Agani, Nr. 12, Pejë",
    parentName: "Qemail Morina",
    startDate: "2024-01-30",
    category: "A2",
    assignedInstructor: "Driton Berisha",
    totalHours: "28",
    bonusHours: "3",
    totalAmount: "520",
    paidAmount: "520",
    theoryTestDate: "2024-03-08",
    practicalTestDate: "",
    status: "active",
    notes: "Motorcycle training",
  },
  {
    candidateId: "CAN2024044",
    firstName: "Qëndresa",
    lastName: "Osmani",
    phoneNumber: "+383 49 444 000",
    email: "",
    personalNumber: "4564568901",
    username: "qendresao",
    password: "QO8901",
    birthday: "2003-12-17",
    gender: "female",
    address: "Rr. UCK, Nr. 34, Prishtinë",
    parentName: "Hajdin Osmani",
    startDate: "2024-03-05",
    category: "B",
    assignedInstructor: "Teuta Kelmendi",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "270",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024045",
    firstName: "Rron",
    lastName: "Tahiri",
    phoneNumber: "+383 45 555 000",
    email: "rron.tahiri@email.com",
    personalNumber: "5675679012",
    username: "rront",
    password: "RT9012",
    birthday: "2002-05-02",
    gender: "male",
    address: "Rr. Nëna Tereze, Nr. 67, Prizren",
    parentName: "",
    startDate: "2024-01-20",
    category: "B",
    assignedInstructor: "Ramiz Dervishi",
    totalHours: "40",
    bonusHours: "5",
    totalAmount: "650",
    paidAmount: "650",
    theoryTestDate: "2024-02-26",
    practicalTestDate: "2024-03-20",
    status: "completed",
    notes: "",
  },
  {
    candidateId: "CAN2024046",
    firstName: "Sara",
    lastName: "Kelmendi",
    phoneNumber: "+383 44 666 000",
    email: "sara.kelmendi@email.com",
    personalNumber: "6786790123",
    username: "sarak",
    password: "SK0123",
    birthday: "2004-09-09",
    gender: "female",
    address: "Rr. Skënderbeu, Nr. 78, Gjakovë",
    parentName: "Armend Kelmendi",
    startDate: "2024-02-26",
    category: "B",
    assignedInstructor: "Arlinda Sylejmani",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "320",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024047",
    firstName: "Taulant",
    lastName: "Sylejmani",
    phoneNumber: "+383 49 777 000",
    email: "",
    personalNumber: "7897891234",
    username: "taulants",
    password: "TS1234",
    birthday: "2001-03-24",
    gender: "male",
    address: "Rr. Dardania, Nr. 45, Prishtinë",
    parentName: "Veton Sylejmani",
    startDate: "2024-02-01",
    category: "B",
    assignedInstructor: "Valmir Tahiri",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "600",
    theoryTestDate: "2024-03-10",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
  {
    candidateId: "CAN2024048",
    firstName: "Urtina",
    lastName: "Shabani",
    phoneNumber: "+383 45 888 000",
    email: "urtina.shabani@email.com",
    personalNumber: "8908902345",
    username: "urtinas",
    password: "US2345",
    birthday: "2003-07-11",
    gender: "female",
    address: "Rr. Bill Clinton, Nr. 90, Prishtinë",
    parentName: "Skender Shabani",
    startDate: "2024-01-24",
    category: "B",
    assignedInstructor: "Besarta Mustafa",
    totalHours: "40",
    bonusHours: "3",
    totalAmount: "620",
    paidAmount: "620",
    theoryTestDate: "2024-03-01",
    practicalTestDate: "2024-03-26",
    status: "active",
    notes: "Ready for test",
  },
  {
    candidateId: "CAN2024049",
    firstName: "Visar",
    lastName: "Krasniqi",
    phoneNumber: "+383 44 999 111",
    email: "visar.krasniqi@email.com",
    personalNumber: "9019013456",
    username: "visark",
    password: "VK3456",
    birthday: "2002-02-06",
    gender: "male",
    address: "Rr. Lidhja e Prizrenit, Nr. 56, Vushtrri",
    parentName: "Ramush Krasniqi",
    startDate: "2023-11-28",
    category: "B",
    assignedInstructor: "Flamur Gashi",
    totalHours: "40",
    bonusHours: "8",
    totalAmount: "680",
    paidAmount: "680",
    theoryTestDate: "2024-01-08",
    practicalTestDate: "2024-02-12",
    status: "completed",
    notes: "Outstanding performance",
  },
  {
    candidateId: "CAN2024050",
    firstName: "Xhensila",
    lastName: "Hoxha",
    phoneNumber: "+383 49 000 222",
    email: "",
    personalNumber: "0120124567",
    username: "xhensilah",
    password: "XH4567",
    birthday: "2004-10-20",
    gender: "female",
    address: "Rr. Ismail Qemali, Nr. 23, Ferizaj",
    parentName: "Blerim Hoxha",
    startDate: "2024-03-14",
    category: "B",
    assignedInstructor: "Linda Hyseni",
    totalHours: "40",
    bonusHours: "0",
    totalAmount: "600",
    paidAmount: "200",
    theoryTestDate: "",
    practicalTestDate: "",
    status: "active",
    notes: "",
  },
];

export const createTestCandidates = async () => {
  try {
    console.log("Starting to create test candidates...");

    // First, fetch all instructors to map names to IDs
    console.log("Fetching instructors...");
    const instructorsRef = collection(db, "instructors");
    const instructorsSnapshot = await getDocs(instructorsRef);
    const instructors = instructorsSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Create a mapping from full name to instructor ID
    const instructorNameToId = {};
    instructors.forEach((instructor) => {
      const fullName = `${instructor.firstName} ${instructor.lastName}`;
      instructorNameToId[fullName] = instructor.id;
    });

    console.log(`Found ${instructors.length} instructors`);

    const candidatesRef = collection(db, "candidates");
    let successCount = 0;

    for (const candidate of testCandidates) {
      try {
        // Convert instructor name to ID
        const instructorId = instructorNameToId[candidate.assignedInstructor];

        // Parse phone number: split prefix and number
        let phonePrefix = "+383"; // Default
        let phoneNumber = candidate.phoneNumber || "";

        if (phoneNumber && phoneNumber.startsWith("+")) {
          // Extract prefix (e.g., +383, +377)
          const match = phoneNumber.match(/^(\+\d{1,4})\s*(.+)$/);
          if (match) {
            phonePrefix = match[1];
            phoneNumber = match[2].replace(/\s/g, ""); // Remove spaces from number
          }
        } else if (phoneNumber) {
          // If no prefix, assume +383 and use the whole number
          phoneNumber = phoneNumber.replace(/\s/g, "");
        }

        const candidateData = {
          ...candidate,
          phonePrefix: phonePrefix,
          phoneNumber: phoneNumber,
          assignedInstructorId: instructorId || "", // Use ID if found
          // Keep assignedInstructor for backwards compatibility, but it won't be used in new code
          createdAt: serverTimestamp(),
        };

        await addDoc(candidatesRef, candidateData);
        successCount++;
        console.log(
          `✓ Created candidate: ${candidate.firstName} ${candidate.lastName} (${
            candidate.candidateId
          }) → Instructor: ${candidate.assignedInstructor} (ID: ${
            instructorId || "N/A"
          })`
        );
      } catch (error) {
        console.error(
          `✗ Failed to create ${candidate.firstName} ${candidate.lastName}:`,
          error
        );
      }
    }

    console.log(
      `\n✅ Successfully created ${successCount} out of ${testCandidates.length} candidates!`
    );
    return { success: true, count: successCount };
  } catch (error) {
    console.error("Error creating test candidates:", error);
    return { success: false, error };
  }
};

export default createTestCandidates;
